module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sh-b0d0251be62a5f27282a01e28be0df50.svg";